import { render } from "./Docs.vue?vue&type=template&id=2bdb9cd9&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2bdb9cd9"

export default script